<script>
export default {
  name: 'ActivitySliderCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    truncateSummary: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <a :href="data.url" class="kb-activity-slider-card">
    <div class="kb-activity-slider-card__top-info">
      <div class="kb-activity-card__label">
        <template v-if="data.type === 'single'">
          <p class="kb-activity-card__label__dates single-date">
            <span class="kb-activity-card__label__date single-date"
              >{{ data.dayRange[0] }}.</span
            >
            <span class="kb-activity-card__label__month single-date">{{
              data.monthName[0]
            }}</span>
          </p>
        </template>
        <template v-else-if="data.monthName.length === 1">
          <p class="kb-activity-card__label__dates single-month">
            <span class="kb-activity-card__label__date"
              >{{ data.dayRange[0] }}.-{{ data.dayRange[1] }}.</span
            >
            <span class="kb-activity-card__label__month">
              {{ data.monthName[0] }}</span
            >
          </p>
        </template>
        <template v-else>
          <p class="kb-activity-card__label__dates">
            <span class="kb-activity-card__label__date"
              >{{ data.dayRange[0] }}.</span
            >
            <span class="kb-activity-card__label__month">{{
              data.monthName[0]
            }}</span>
            <br />-<br />
            <span class="kb-activity-card__label__date"
              >{{ data.dayRange[1] }}.</span
            >
            <span class="kb-activity-card__label__month">{{
              data.monthName[1]
            }}</span>
          </p>
        </template>
      </div>
      <div class="kb-activity-card__event-info">
        <div class="kb-activity-card__event-info__event-data__wrapper">
          <div class="kb-activity-card__event-info__event-data__container">
            <div class="kb-activity-card__event-info__event-data__icon-wrapper">
              <svg viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" role="presentation">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.75 5C0.75 2.65279 2.65279 0.75 5 0.75C7.34721 0.75 9.25 2.65279 9.25 5C9.25 6.94234 8.13878 9.10096 7.00812 10.787L6.14901 10.1493L5.85099 10.5507L7.12762 11.4984L7.27448 11.2847C8.4599 9.56044 9.75 7.18962 9.75 5C9.75 2.37665 7.62335 0.25 5 0.25C2.37665 0.25 0.25 2.37665 0.25 5C0.25 7.07894 1.41271 9.31976 2.54199 11.0137C3.11055 11.8665 3.67867 12.5924 4.10458 13.1051C4.31764 13.3615 4.49541 13.565 4.62023 13.7047C4.68264 13.7745 4.73184 13.8284 4.76562 13.8651C4.78251 13.8834 4.79554 13.8974 4.80445 13.907L4.81468 13.9179L4.81741 13.9208L4.81839 13.9218L5 14.1135L5.18305 13.9203L5.18703 13.9161L5.20201 13.9C5.21507 13.886 5.23419 13.8654 5.25885 13.8385C5.30818 13.7846 5.37973 13.7054 5.46951 13.6035C5.64904 13.3996 5.90163 13.1044 6.19525 12.7372L5.80475 12.4249C5.51675 12.7851 5.26934 13.0743 5.09428 13.273C5.05999 13.312 5.02848 13.3474 5 13.3793L4.99305 13.3715C4.87178 13.2358 4.69798 13.0369 4.48917 12.7856C4.07133 12.2826 3.51445 11.571 2.95801 10.7363C1.83729 9.05524 0.75 6.92106 0.75 5ZM5 13.75L4.81839 13.9218C4.81839 13.9218 4.81851 13.9219 5 13.75Z"
                  fill="#3C3C3C"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5 1.75C3.20507 1.75 1.75 3.20507 1.75 5C1.75 6.79493 3.20507 8.25 5 8.25C6.79493 8.25 8.25 6.79493 8.25 5C8.25 3.20507 6.79493 1.75 5 1.75ZM2.25 5C2.25 3.48122 3.48122 2.25 5 2.25C6.51878 2.25 7.75 3.48122 7.75 5C7.75 6.51878 6.51878 7.75 5 7.75C3.48122 7.75 2.25 6.51878 2.25 5Z"
                  fill="#3C3C3C"
                />
              </svg>
            </div>
            <p>{{ data.city }}</p>
          </div>

          <div class="kb-activity-card__event-info__event-data__container">
            <div class="kb-activity-card__event-info__event-data">
              <div
                :class="`kb-activity-card__event-status-${data.type} ${data.statusColor}`"
                class="kb-activity-card__event-info__event-data__icon-wrapper kb-activity-card__event-info__event-data__icon-wrapper--solid-icon"
              ></div>
            </div>
            <p>{{ data.statusDisplayName }}</p>
          </div>

          <template v-if="data.typeDisplayName">
            <div class="kb-activity-card__event-info__event-data__container">
              <div class="kb-activity-card__event-info__event-data">
                <div
                  class="kb-activity-card__event-info__event-data__icon-wrapper"
                >
                  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="presentation">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3 2H2.5V3H1.5H1V4.5H1.5V3.5H2.5V4.5H3V3.5H6V4.5H6.5V3.5H9.5V4.5H10V3.5H13V4.5H13.5V3.5H14.5V6H1.5H1V6.5V13V13.5H15V13V6.5V6V3H14.5H13.5V2H13V3H10V2H9.5V3H6.5V2H6V3H3V2ZM14.5 13V6.5H1.5L1.5 13H14.5Z"
                      fill="#3C3C3C"
                    />
                  </svg>
                </div>
              </div>
              <p>{{ data.typeDisplayName }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>

    <h3 class="kb-activity-card__event-info__title">{{ data.eventName }}</h3>
    <p class="kb-activity-card__event-info__text">
      {{ truncateSummary(data.summary) }}
    </p>
  </a>
</template>
